import { useEffect } from 'react';

export const TinyAdsScript = () => {
  useEffect(() => {
    // Check if script already exists
    if (document.querySelector('script[src*="apitiny.net/scripts/v2.0/main.js"]')) return;

    const script = document.createElement('script');
    script.src = 'https://cdn.apitiny.net/scripts/v2.0/main.js';
    script.async = true;
    script.setAttribute('data-site-id', '6963c9b4547953f4d898a5fe');
    script.setAttribute('data-test-mode', 'false');
    document.body.appendChild(script);

    return () => {
      // Optional: cleanup if component unmounts
      // script.remove();
    };
  }, []);

  return null; // no visible element
};
